import { render } from "./Foreign.vue?vue&type=template&id=50f7ffb4&scoped=true"
import script from "./Foreign.vue?vue&type=script&lang=js"
export * from "./Foreign.vue?vue&type=script&lang=js"

import "./Foreign.vue?vue&type=style&index=0&id=50f7ffb4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f7ffb4"]])

export default __exports__